import React from 'react'
import NavNextLink from '@/components/EMT/NavNextLink'
import { Routes } from '@/assets/configs'
import { Box } from '@mui/material'
import AddBox from '@/components/PetSitter/AddBox'

// Store
import { useUIStore } from '@/store/ui/uiStore'

// Types
import { ConnectedUserAnimal } from '@/dataV3/Animal/ConnectedUserAnimal'
import InlinePet from '@/components/EMT/InlinePet'

type ProfileMenuPetsProps = {
  pets?: ConnectedUserAnimal[]
  variant?: 'seePets' | 'editPets'
  onClick?: () => void
}

const ProfileMenuPets: React.FC<ProfileMenuPetsProps> = ({ pets, variant = 'editPets', onClick }) => {
  const { openAddPetModal } = useUIStore()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: '318px' }} onClick={onClick}>
      {pets &&
        pets.map((pet) => (
          <NavNextLink
            key={pet.id}
            href={variant === 'editPets' ? Routes.MyPetProfile(pet.id) : Routes.Profile(pet.id)}
            sx={{
              flexDirection: 'row !important',
            }}
          >
            <InlinePet pet={pet} />
          </NavNextLink>
        ))}
      {variant === 'editPets' && <AddBox handleAddPet={openAddPetModal} />}
    </Box>
  )
}

export default ProfileMenuPets
